<template>
	<div>
		<div v-if="loggedInEmployee.isAdmin">
			<v-card class="mb-4">
				<v-divider></v-divider>

				<v-card-text class="text-xs-left">
					<v-subheader class="mb-3"> This section allows you to control the categories that are used to break down a Position Description. i.e "Project Management", "Teamwork", "Communication" </v-subheader>

					<categories-list :categories="categories" @onEditCategory="onEditCategory" @onDeleteCategory="onDeleteCategory"> </categories-list>

					<category-editor :dialog="categoryEditorDialog" :title="categoryEditorTitle" :category="editedCategory" @save="saveCategory" @closeEditor="categoryEditorDialog = false"> </category-editor>
				</v-card-text>
			</v-card>

			<v-footer color="" app height="55">
				<v-spacer></v-spacer>
				<footer-add-btn @click="onAddCategory">Add Category</footer-add-btn>
			</v-footer>
		</div>
		<div v-else>You do not have access</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import CategoriesList from '@/components/CategoriesList';
	import CategoryEditor from '@/components/CategoryEditor';

	export default {
		components: {
			CategoriesList,
			CategoryEditor
		},
		data() {
			return {
				categoryEditorDialog: false,
				editedCategoryIndex: -1,
				editedCategory: undefined
			};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Position Categories');
		},
		computed: {
			...mapGetters({
				categories: 'categories/categories',
				loggedInEmployee: 'loggedInEmployee'
			}),
			categoryEditorTitle() {
				return this.editedCategoryIndex === -1 ? 'New Category' : 'Edit Category';
			}
		},
		methods: {
			onEditCategory(category) {
				this.editedCategoryIndex = this.categories.indexOf(category);
				this.editedCategory = Object.assign({}, category);
				this.categoryEditorDialog = true;
			},
			onDeleteCategory(category) {
				const index = this.categories.indexOf(category);
				if (confirm('Are you sure you want to delete this category?')) {
					this.$store.dispatch('categories/delete', category).then(
						(response) => {},
						(error) => {
							console.error('Error deleting category');
						}
					);
				}
			},
			onAddCategory() {
				this.editedCategoryIndex = -1;
				this.editedCategory = undefined;
				this.categoryEditorDialog = true;
			},
			saveCategory(category) {
				if (this.editedCategoryIndex > -1) {
					this.$store.dispatch('categories/edit', category).then(
						(response) => {},
						(error) => {
							console.error('Error saving category');
						}
					);
				} else {
					this.$store.dispatch('categories/add', category).then(
						(response) => {},
						(error) => {
							console.error('Error saving category');
						}
					);
				}
			}
		}
	};
</script>

<style></style>
